import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const ChildFamilyConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/child-family-support",
    component: React.lazy(() => import("./child-family-support")),
  },
];
